(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sku-delivery-promise"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sku-delivery-promise')) {
  class SkuDeliveryPromise extends HTMLElement {
    connectedCallback() {
      this.headlineEl = this.querySelector('.js-sku-delivery-headline');
      this.detailEl = this.querySelector('.js-sku-delivery-detail');
      this.render();
      this.timer = setInterval(() => this.render(), 30000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    getPayload() {
      const dataEl = this.querySelector('[type="application/json"]');
      if (!dataEl) return { sku: '', available: false };
      try {
        return JSON.parse(dataEl.textContent);
      } catch (error) {
        return { sku: '', available: false };
      }
    }

    interpolate(template, vars) {
      return String(template || '').replace(/\{\{\s*(\w+)\s*\}\}/g, (_, key) => (
        vars[key] == null ? '' : String(vars[key])
      ));
    }

    escapeHtml(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    londonParts(date) {
      const parts = {};
      new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London',
        weekday: 'short',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23'
      }).formatToParts(date).forEach((part) => {
        if (part.type !== 'literal') parts[part.type] = part.value;
      });
      return {
        year: Number(parts.year),
        month: Number(parts.month),
        day: Number(parts.day),
        hour: Number(parts.hour),
        minute: Number(parts.minute),
        weekday: parts.weekday
      };
    }

    londonYmd(date) {
      const parts = this.londonParts(date);
      const month = String(parts.month).padStart(2, '0');
      const day = String(parts.day).padStart(2, '0');
      return `${parts.year}-${month}-${day}`;
    }

    londonOffsetMs(date) {
      const tz = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London',
        timeZoneName: 'longOffset'
      }).formatToParts(date).find((part) => part.type === 'timeZoneName');
      const match = (tz && tz.value ? tz.value : 'GMT+00:00').match(/GMT([+-])(\d{1,2})(?::(\d{2}))?/);
      if (!match) return 0;
      const sign = match[1] === '+' ? 1 : -1;
      return sign * ((Number(match[2]) * 60) + Number(match[3] || 0)) * 60 * 1000;
    }

    londonWallTime(ymd, hour, minute) {
      const bits = ymd.split('-').map(Number);
      const utcGuess = Date.UTC(bits[0], bits[1] - 1, bits[2], hour, minute, 0);
      return new Date(utcGuess - this.londonOffsetMs(new Date(utcGuess)));
    }

    addCalendarDays(date, days) {
      const parts = this.londonParts(date);
      return new Date(Date.UTC(parts.year, parts.month - 1, parts.day + days, 12, 0, 0));
    }

    isWeekend(date) {
      const weekday = this.londonParts(date).weekday;
      return weekday === 'Sat' || weekday === 'Sun';
    }

    nextWeekday(fromDate, includeToday) {
      let offset = includeToday ? 0 : 1;
      while (true) {
        const candidate = this.addCalendarDays(fromDate, offset);
        if (!this.isWeekend(candidate)) return candidate;
        offset += 1;
      }
    }

    addWorkingDays(fromDate, count) {
      let added = 0;
      let offset = 0;
      while (added < count) {
        offset += 1;
        const candidate = this.addCalendarDays(fromDate, offset);
        if (!this.isWeekend(candidate)) added += 1;
      }
      return this.addCalendarDays(fromDate, offset);
    }

    formatDate(date) {
      const parts = {};
      new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London',
        weekday: 'long',
        day: 'numeric',
        month: 'short'
      }).formatToParts(date).forEach((part) => {
        if (part.type !== 'literal') parts[part.type] = part.value;
      });
      return `${parts.weekday} ${parts.day} ${parts.month}`;
    }

    formatRemaining(ms) {
      const totalMins = Math.max(0, Math.floor(ms / 60000));
      const hours = Math.floor(totalMins / 60);
      const minutes = totalMins % 60;
      if (hours > 0) {
        return this.interpolate(this.dataset.timeHm, { hours, minutes });
      }
      return this.interpolate(this.dataset.timeM, { minutes });
    }

    isPSku(sku) {
      return /^P\d/i.test(String(sku || '').trim());
    }

    render() {
      const payload = this.getPayload();
      if (!payload.available) {
        this.hidden = true;
        return;
      }

      this.hidden = false;
      const isP = this.isPSku(payload.sku);
      const cutoffHour = isP ? 15 : 16;
      const transitDays = isP ? 2 : 1;
      const now = new Date();
      const nowParts = this.londonParts(now);
      const beforeCutoff = nowParts.hour < cutoffHour;
      const dispatchToday = !this.isWeekend(now) && beforeCutoff;
      const dispatchDate = this.nextWeekday(now, dispatchToday);
      const deliveryDate = this.addWorkingDays(dispatchDate, transitDays);
      const dateLabel = this.formatDate(deliveryDate);
      const cutoffLabel = isP ? this.dataset.cutoffP : this.dataset.cutoffStd;

      this.headlineEl.textContent = this.interpolate(this.dataset.headline, { date: dateLabel });

      if (dispatchToday) {
        const cutoffAt = this.londonWallTime(this.londonYmd(now), cutoffHour, 0);
        const template = isP ? this.dataset.withinTwoDay : this.dataset.withinNextDay;
        const timeLabel = this.escapeHtml(this.formatRemaining(cutoffAt - now));
        this.detailEl.innerHTML = this.interpolate(template, {
          time: `<span class="sku-delivery-promise__time">${timeLabel}</span>`
        });
      } else {
        const template = isP ? this.dataset.afterTwoDay : this.dataset.afterNextDay;
        this.detailEl.textContent = this.interpolate(template, { cutoff: cutoffLabel });
      }
    }
  }

  customElements.define('sku-delivery-promise', SkuDeliveryPromise);
}
  } catch(e) { console.error(e); }
})();

})();
